import { render } from "./SerialDetail.vue?vue&type=template&id=4a690c7c&scoped=true"
import script from "./SerialDetail.vue?vue&type=script&lang=ts"
export * from "./SerialDetail.vue?vue&type=script&lang=ts"

import "./SerialDetail.vue?vue&type=style&index=0&id=4a690c7c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4a690c7c"

export default script